// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UqB2DR-M","st0":"_1kDXb1Ja","st1":"_3rIWWcsL","st2":"DnvoofJ9","st3":"_2wEHqIuD","st4":"_2u3K9i1z","st5":"-SH4H6TK","mainPic":"C77ThWrO","textContainer":"_11e6fGDd","picTitle":"_1rTe5ItR","picText":"FmeAbB9b"};
    if(module.hot) {
      // 1754514968471
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  